<div
  class="reminder__container"
  [class.reminder__container--dismissed]="isDismissed"
  [class.reminder__container--overdue]="isOverdue"
  (click)="viewReminder()"
>
  <section class="reminder__inner" [class.reminder__inner--snoozed]="isSnoozed">
    <span class="reminder__reminderName">{{ ppReminder.name }}</span>
    <div class="reminder__dueDateContainer">
      <time class="reminder__dueDate" aria-label="Due date">{{ reminderDueTime }} </time>
      @if (ppReminder.seriesId) {
        <pp-icon
          ppColor="inherit"
          ppClass="setSize14"
          [ppSrc]="EIconPath.ICON_MISC_RECURRING_ICON_12"
          ppTooltip
        ></pp-icon>
      }

      @if (createdForMe) {
        <pp-icon
          ppColor="inherit"
          ppClass="setSize12"
          [ppSrc]="EIconPath.ICON_ROUND_PEOPLE_SINGLE_12"
          ppTooltip
          [ppTitle]="'reminder_created_for_you' | ppTranslate"
        ></pp-icon>
      }

      @if (createdForOthers) {
        <pp-icon
          ppColor="inherit"
          ppClass="setSize12"
          [ppSrc]="EIconPath.ICON_ROUND_PEOPLE_12"
          ppTooltip
          [ppTitle]="'reminder_created_by_you_for_others' | ppTranslate"
        ></pp-icon>
      }
    </div>
  </section>

  @if (isSnoozed) {
    <div class="reminder__snooze">
      <pp-icon
        ppColor="inherit"
        ppClass="setSize18"
        [ppSrc]="EIconPath.ICON_MISC_SNOOZE_18"
        ppTooltip
        [ppTitle]="showSnoozeTooltip ? reminderSnoozeTime : ''"
      ></pp-icon>
      <p class="reminder__snoozeTime">
        {{ reminderSnoozeTime }}
      </p>
    </div>
  }
</div>
